import { Component, Input, OnInit } from '@angular/core';
import { Patient, Sex } from 'src/app/model/patient.model';

@Component({
  selector: 'app-patient-item',
  templateUrl: './patient-item.component.html',
  styleUrls: ['./patient-item.component.scss'],
})
export class PatientItemComponent implements OnInit {

  @Input() patient: Patient;

  constructor() { }

  ngOnInit() {}

  isMale(patient: Patient): boolean {
    if (patient !== null && patient !== undefined &&
        patient.demoscopicData !== null && patient.demoscopicData !== undefined &&
        patient.demoscopicData.sex === Sex.MALE) {
      return true;
    }
    return false;
  }

  isFemale(patient: Patient): boolean {
    if (patient !== null && patient !== undefined &&
        patient.demoscopicData !== null && patient.demoscopicData !== undefined &&
        patient.demoscopicData.sex === Sex.FEMALE) {
      return true;
    }
    return false;
  }

}
